export default __webpack_public_path__ + "content/media/26.aa34354a.jpg";